import { ModalFilter } from '../../types';

import { ReturnedAction } from '../reduxTypes';

interface DateFilters {
  range: string;
  custom?: Array<number | string>;
  customNotes?: Array<number | string>;
}

export const setMarketFilters = (value: Array<ModalFilter | null>): ReturnedAction => ({
  type: 'SET_MARKET_FILTERS',
  value
});

export const setDatesFilters = (value: DateFilters): ReturnedAction => ({
  type: 'SET_DATES_FILTERS',
  value
});
